import { render } from "./SwitchToMainAccountModal.vue?vue&type=template&id=5dbed15e&scoped=true"
import script from "./SwitchToMainAccountModal.vue?vue&type=script&lang=js"
export * from "./SwitchToMainAccountModal.vue?vue&type=script&lang=js"

import "./SwitchToMainAccountModal.vue?vue&type=style&index=0&id=5dbed15e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbed15e"]])

export default __exports__